// @file Helper functions for auth pages
const INPUT_HEIGHT = 40 // the height of the input field
const SCROLLABLE_BUFFER = 40 // extra buffer to account for small viewport shifts (e.g. third-party keyboards)
const SCROLLABLE_THRESHOLD = INPUT_HEIGHT + SCROLLABLE_BUFFER

interface LoginMethod {
  name: string
  url?: string
  displayName?: string
  logo?: string
  devMode?: boolean | null
}

const normalizeThirdPartyLoginMethods = (methods: LoginMethod[]): Record<string, LoginMethod> => {
  const loginMethods: Record<string, LoginMethod> = {}

  for (const method of methods) {
    if (method.name === 'password' || method.name.startsWith('saml')) continue
    loginMethods[method.name] = method
  }

  return loginMethods
}

export { normalizeThirdPartyLoginMethods, SCROLLABLE_THRESHOLD }
export type { LoginMethod }
